export const differenceRows = [
  {
    dimension: "身份来源",
    novel: "《水浒传》中身世简略，仅交代其由婢女被许配给武大郎。",
    film: "多数影视作品会补充家世或成长片段，让她的来历更完整、动机更可理解。",
  },
  {
    dimension: "人物重心",
    novel: "原著更关注“奸情—复仇”的情节推进，人物服从于故事的道德结构。",
    film: "改编常把重心移到人物心理，用更多篇幅呈现她的处境、挣扎与选择。",
  },
  {
    dimension: "结局处理",
    novel: "以武松复仇作结，强调因果与惩戒，叙事利落。",
    film: "部分作品淡化复仇的爽感，转而渲染悲剧气氛，或改以倒叙、双时空收尾。",
  },
  {
    dimension: "形象基调",
    novel: "整体偏向道德评判，人物更像一个被警示的符号。",
    film: "不同版本分歧明显，有的延续负面塑造，有的强化其凄美与无奈。",
  },
  {
    dimension: "时代视角",
    novel: "反映成书时代的家庭伦理与性别秩序。",
    film: "改编者往往代入当代的性别观念与审美，使同一角色呈现不同面貌。",
  },
];